module.exports = {
  name: '出勤查核資料',
  schema: {
    type: 'Object',
    contents: {
      date: { type: 'Date', name: '日期', format: 'YYYY/MM/DD' },
      stafferRef: {
        type: 'ObjectId',
        name: '人員',
        reference: 'staffers',
        refKeys: ['name'],
      },
      note: { type: 'String', name: '查核註記' },
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'date' },
        { key: 'stafferRef' },
        { key: 'note', width: 200 },
      ],
    },
    editor: {
      groups: [
        {
          name: '系統資料',
          rows: [
            [{ key: 'name' }],
            [{ key: 'stafferRef' }],
            [{ key: 'note' }],
          ],
        },
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./src/models/attendanceRecords.js